module.exports = __webpack_public_path__ + "static/media/amazon-ses-logo.4d8ee027.png";